import type { RootThunkDispatch } from 'store'
import { FETCHED } from './actionTypes'
import * as contentApi from 'services/content'

function cleanPath(path: string) {
  return path.replace(/\/$/, '')
}

export function fetchPage(path: string) {
  return async (dispatch: RootThunkDispatch, getState) => {
    const pages = getState().pages

    const fetchedPath = pages.path === '/home' ? '/' : pages.path

    if (fetchedPath === path) {
      return Promise.resolve()
    }

    const response = await contentApi.fetchPage(cleanPath(path) || '/')

    dispatch({
      type: FETCHED,
      payload: response,
    })
  }
}
